<template>
  <v-app>
    <!-- <navigation-bar /> -->
    <v-main>
       <!-- Menú superior -->
      <navigation-bar></navigation-bar>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import NavigationBar from "@/components/NavigationBar.vue";
export default {
  name: "App",
  components: {
    NavigationBar,
  },
  methods:{
    ...mapActions(['setIsAdmin','setIsPlayMode']),
    ...mapActions("nodered", ["createConnection"]),

  },
  mounted(){
    if(JSON.parse(localStorage.getItem("user"))){

      this.setIsAdmin(JSON.parse(localStorage.getItem("user")).role_name == 'admin')
      if (!this.getIsAdmin) {
        this.setIsPlayMode(true);
      }else{
        this.setIsPlayMode(false)
      }
    }
  },
  async created() {
    await this.createConnection()
    
  },
  computed:{
    ...mapGetters(['getIsAdmin'])
  }
};
</script>
